import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ConvexReactClient } from "convex/react";
import { ConvexAuthProvider } from "@convex-dev/auth/react";
import { HelmetProvider } from 'react-helmet-async';
import { PostHogProvider } from './reactvideoeditor/pro/components/providers/posthog-provider';
import { ThemeProvider } from './providers/ThemeProvider';
import { Toaster } from './reactvideoeditor/pro/components/ui/toaster';
import { Toaster as SonnerToaster } from 'sonner';
import { Home } from './pages/Home';
import { Editor } from './pages/Editor';
import { RemoveBackground } from './pages/tools/RemoveBackground';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AdminRoute } from './components/AdminRoute';
import { AudioUploadPanel } from './components/admin/AudioUploadPanel';

const convex = new ConvexReactClient(import.meta.env.VITE_CONVEX_URL as string);

export function App() {
  return (
    <ConvexAuthProvider client={convex}>
      <HelmetProvider>
        <ThemeProvider>
          <PostHogProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/tools/remove-video-background" element={<RemoveBackground />} />
                <Route
                  path="/editor"
                  element={
                    <ProtectedRoute>
                      <Editor />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/audio"
                  element={
                    <AdminRoute>
                      <AudioUploadPanel />
                    </AdminRoute>
                  }
                />
              </Routes>
              <Toaster />
              <SonnerToaster />
            </BrowserRouter>
          </PostHogProvider>
        </ThemeProvider>
      </HelmetProvider>
    </ConvexAuthProvider>
  );
}

